export enum ILoadBalancerDetailsPageTabs {
  LoadBalancers = 'loadBalancers',
  Listeners = 'listeners',
  Pools = 'pools',
  Members = 'members',
  Monitors = 'monitors',
}
export enum IHealthServiceDetailsPageTabs {
  ServiceHealth = 'serviceHealth',
  HostHealth = 'hostHealth',
  ControlPlaneServicesHealth = 'controlPlaneServicesHealth',
}
export enum IProtocols {
  TCP = 'TCP',
  UDP = 'UDP',
  SCTP = 'SCTP',
}

export enum ITypes {
  TCP = 'TCP',
  UDPCONNECT = 'UDP-CONNECT',
  SCTP = 'SCTP',
}

export enum ILoadBalancingAlgorithm {
  ROUND_ROBIN = 'ROUND_ROBIN',
  LEST_CONNECTIONS = 'LEST_CONNECTIONS',
  SOURCE_IP_PORT = 'SOURCE_IP_PORT',
}

export interface Pagination {
  limit: number
  offset: number
  total: number
}
export interface NetworksResponse {
  networks: Network[]
  pagination: Pagination
}

export interface NetworkDetailsResponse {
  network: Network
}

export interface AllocationPool {
  start: string
  end: string
}

export interface HostRoute {
  destination: string
  nexthop: string
}

export interface SubnetIPAvailability {
  used_ips: number
  total_ips: number
  subnet_id: string
  ip_version: number
  cidr: string
  subnet_name: string
}

export interface NetworkIPAvailability {
  used_ips: number
  total_ips: number
  network_id: string
  network_name: string
  tenant_id: string
  project_id: string
}

export interface Subnet {
  id: string
  name: string
  tenant_id: string
  project_id: string
  network_id: string
  ip_version: 4 | 6
  cidr: string
  gateway_ip: string | null
  enable_dhcp: boolean
  ipv6_ra_mode: string | null
  ipv6_address_mode: string | null
  subnetpool_id: string | null
  segment_id: string | null
  allocation_pools: AllocationPool[]
  subnet_ip_availability: SubnetIPAvailability
  created_at: string
  updated_at: string
  description: string
  revision_number: number
  tags: string[]
  host_routes: HostRoute[]
  dns_nameservers: string[]
  service_types: string[]
  dns_publish_fixed_ip: boolean
}

export interface FixedIP {
  subnet_id: string
  ip_address: string
}

export interface AllowedAddressPair {
  ip_address: string
  mac_address?: string
}

export interface ExtraDhcpOption {
  opt_name: string
  opt_value: string
}

export interface SecurityGroup {
  id: string
  name: string
}

export interface DnsAssignment {
  hostname: string
  fqdn: string
  ip_address: string
}

export interface Port {
  id: string
  name: string
  network_id: string
  project_id: string
  tenant_id: string

  mac_address: string
  admin_state_up: boolean
  status: 'ACTIVE' | 'DOWN' | 'BUILD' | 'ERROR' | string

  device_id: string
  device_owner: string

  created_at: string
  updated_at: string
  description: string
  revision_number: number

  port_security_enabled: boolean
  tags: string[]

  fixed_ips: FixedIP[]
  allowed_address_pairs: AllowedAddressPair[]
  extra_dhcp_opts: ExtraDhcpOption[]

  security_groups: SecurityGroup[]

  /** Binding attributes */
  'binding:vnic_type': string
  'binding:profile': Record<string, unknown>
  'binding:host_id': string
  'binding:vif_type': string
  'binding:vif_details': Record<string, unknown>

  qos_policy_id: string | null
  qos_network_policy_id: string | null

  dns_name: string
  dns_domain: string
  dns_assignment: DnsAssignment[]
}

export interface Network {
  id: string
  project_id: string
  tenant_id: string
  name: string
  status: 'ACTIVE' | 'DOWN' | string
  admin_state_up: boolean
  availability_zone_hints: string[]
  availability_zones: string[]
  vlan_transparent: boolean | null
  mtu: number
  shared: boolean
  shared_tenants: string[]
  created_at: string
  updated_at: string
  description: string
  revision_number: number
  subnets: Subnet[]
  network_ip_availability: NetworkIPAvailability
  tags: string[]
  ports: Port[]
  /** Provider attributes */
  'provider:network_type': string
  'provider:physical_network': string | null
  'provider:segmentation_id': number | null
  /** Router / Security */
  'router:external': boolean
  port_security_enabled: boolean
  qos_policy_id: string | null
  dns_domain: string
  ipv4_address_scope: string | null
  ipv6_address_scope: string | null
}

export interface INetworkSelector extends Network {
  type: string
  subnetDetails: any[]
  availableIps: number
  ports: any[]
  isSimpleNetwork: boolean // NEW: true if network is L2-only/simple network (based on tags)
}
